import { timeout, delay } from '@ynap/promise-utils';
import { ResponseError, Person } from '@ynap/api-utils';
import { FETCH_USER_PREFERENCES_REQUEST, FETCH_USER_PREFERENCES_SUCCESS, FETCH_USER_PREFERENCES_ERROR } from '../constants/ActionTypes';
import { push } from 'connected-react-router';

export function fetchUserPreferencesRequest() {
    return {
        type: FETCH_USER_PREFERENCES_REQUEST,
    };
}

export function fetchUserPreferencesSuccess(preferences) {
    return {
        type: FETCH_USER_PREFERENCES_SUCCESS,
        body: preferences,
    };
}

export function fetchUserPreferencesError() {
    return {
        type: FETCH_USER_PREFERENCES_ERROR,
    };
}

export function getUserPreferencesRequest(baseUrl, brandId, country, uberToken, clientId, clientSecret) {
    return Person.getUserPreferences({
        baseUrl,
        brandId,
        country,
        uberToken,
        clientId,
        clientSecret,
    });
}

export function getFetchUserPreferencesRequest(baseUrl, brandId, country, uberToken, clientId, clientSecret, clientRequest) {
    const request = getUserPreferencesRequest(baseUrl, brandId, country, uberToken, clientId, clientSecret);

    return delay(timeout(fetch(request), clientRequest.timeout), clientRequest.delay);
}

export default function fetchUserPreferences() {
    return (dispatch, getState) => {
        const { locale, config, router, uberToken } = getState();
        const { location = {} } = router;
        const { country } = locale;
        const { pathname } = location;
        const { clientRequest } = config.head || config;
        const { baseUrl, clientId, clientSecret } = config.watsonService || config.global.services.commerce;
        const { brandId } = config.watsonService || config.global.application;

        if (!uberToken) {
            return dispatch(push(`/${locale.id}/account/login?redirect=${pathname}`));
        }

        dispatch(fetchUserPreferencesRequest());

        //todo look at if this is shareable across state packages
        return getFetchUserPreferencesRequest(baseUrl, brandId, country, uberToken, clientId, clientSecret, clientRequest)
            .then((res) => {
                const { ok, status } = res;
                if (ok) {
                    return res.json().then((json) => dispatch(fetchUserPreferencesSuccess(json)));
                } else if (status === 401) {
                    return dispatch(push(`/${locale.id}/account/login?redirect=${pathname}`));
                }

                throw new ResponseError(res);
            })
            .catch((error) => {
                dispatch(fetchUserPreferencesError());
                throw error;
            });
    };
}
